<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle"
            data-toggle="collapse"
            data-target="#navigation-example-2"
            @click="toggleNavbar"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link
            class="navbar-brand"
            to="/admin"
          ><img
              :src="logo"
              alt="TEFL Org Logo"
              width="150"
            ></router-link>
        </div>

      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div
        class="full-page login-page"
        data-color="green"
        data-image="static/img/background/background-5.png"
      >
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <div
                  class="card"
                  data-background="color"
                  data-color="blue"
                >
                  <el-tabs
                    type="border-card"
                    v-model="activeTab"
                  >
                    <el-tab-pane
                      label="Partner Login"
                      name="partner"
                    
                    >
                      <form
                        method="#"
                        action="#"
                        @submit.prevent="login"
                      >
                        <div
                          class=""
                          data-background="color"
                          data-color="blue"
                        >
                          <div class="card-header">
                            <h3 class="card-title">Partner Login</h3>
                          </div>
                          <div class="card-content">
                            <div
                              v-if="error"
                              @hide="hideError"
                              class="alert alert-danger"
                            >
                              <button
                                type="button"
                                class="close"
                                v-on:click="hideError()"
                              >×</button>
                              <span>
                                <b> Error - </b> Your username or password is incorrect</span>
                            </div>
                            <div class="form-group">
                              <label>Username</label>
                              <input
                                required
                                @focus="hideError()"
                                v-model="username"
                                type="text"
                                placeholder="Enter email"
                                class="form-control input-no-border"
                              >
                            </div>
                            <div class="form-group">
                              <label>Password</label>
                              <input
                                required
                                @focus="hideError()"
                                v-model="password"
                                type="password"
                                placeholder="Password"
                                class="form-control input-no-border"
                              >
                            </div>
                          </div>
                          <div class="card-footer text-center">
                            <button
                              type="submit"
                              class="btn btn-fill btn-wd "
                            >Login</button>
                          </div>
                        </div>
                      </form>
                    </el-tab-pane>
                  
                  </el-tabs>
                </div>

              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              &copy; Coded with
              <i class="fa fa-heart heart"></i> by
              <a
                href="https://www.tefl.org/"
                target="_blank"
              >TEFL Org</a>.
            </div>
          </div>
        </footer>
       

      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link
          to="/register"
          tag="li"
        >
          <a>Register</a>
        </router-link>
        <router-link
          to="/admin/overview"
          tag="li"
        >
          <a>Dashboard</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import { AUTH_REQUEST } from '../../store/actions/auth'
import { USER_REQUEST } from '../../store/actions/user'
export default {
  props: {
      logo: {
        type: String,
        default: 'static/img/TEFL-Logo-White.svg'
      }
  },
  data () {
    return {
      username: '',
      password: '',
      activeTab:'partner',
      tutor:false,
      error: false
    }
  },
  methods: {
    login: function () {   
      const { username, password } = this;
      this.$store.dispatch(AUTH_REQUEST, { username, password })
      .then((resp) => {
        console.log(resp)
        console.log('isAuthenticated',this.$store.getters.isAuthenticated)

       if (this.$store.getters.isAuthenticated){
         console.log('ok >>>>')
          this.$store.dispatch(USER_REQUEST).then((x) => {
            console.log('..........',x)
             if(this.$store.getters.getProfile.name=='tefl'){
            this.$router.push('/home')
          }
          else{this.$router.push('/customer/list')}
                    
            
          });
       }
         
      })
      .catch(() => {
        this.error = true
      })
    
    },
    hideError() {
        this.error = false
    },
    toggleNavbar() {
      document.body.classList.toggle('nav-open')
    },
    closeMenu() {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
  beforeDestroy() {
    this.error = false;
    this.closeMenu();
  
  }
},
  mounted() {
  
      this.activeTab = "partner";
   
  },
  watch: {
    "$route": function(route) {
      console.log("watching...,",route);
      //this.getOrder(id);
     
        this.activeTab = "partner";
        this.tutor=false
      
    }
  }
    
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue